module.exports = __webpack_public_path__ + "img/vertical_7_5_5010.77df0b8d.png";